import React from 'react';
import RoleBasedRoute from './RoleBasedRoute';

/**
 * Protected route specifically for admin users (superadmin and subadmin)
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authenticated
 * @returns {React.ReactNode} - The protected component or redirect
 */
const AdminRoute = ({ children }) => {
  return (
    <RoleBasedRoute 
      allowedRoles={['superadmin', 'subadmin']} 
      redirectPath="/admin/login"
    >
      {children}
    </RoleBasedRoute>
  );
};

export default AdminRoute;
